export class SoundConstants {
    public static MUSIC: string = "music";

    public static BUTTON_CLICK: string = "button_click";
    public static BUTTON_ROLLOVER: string = "button_rollover";

    public static TIME_OUT: string = "time_out";
    public static ROUND_WIN: string = "round_win";
    public static TIMER_WARNING: string = "timer_warning";
    public static TYPE: string = "type";

    public static MINIGAME_FAIL: string = "time_out";
}
